module.exports = __webpack_public_path__ + "img/icon_inspect_month.b0ce879a.png";